import { render } from "./DetailRouter.vue?vue&type=template&id=876fd7f6"
import script from "./DetailRouter.vue?vue&type=script&lang=js"
export * from "./DetailRouter.vue?vue&type=script&lang=js"

import exportComponent from "E:\\workspace\\moolng-cms-parent\\moolng-lunzhongyi-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__